import React from "react"; 

import classNames from 'classnames';
import { connect } from 'react-redux';
import ReturnPopUp from './ReturnPopUp';
import RMAPopUP from './RMAPopUp';
import { getRMAData,fetchRMAItemDetails } from '../../redux/actions/orderAction'
import { ORIGIN_ID, PRODUCTION_PATH, RETURNINSTRUCTIONS_PAGE } from "../../AppConfig";
import {NavLink} from "react-router-dom";
import $ from 'jquery'; 

class OrderItemListing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            storeClerkToken: window.sessionStorage.getItem('storeClerkToken'),
            storeId: window.sessionStorage.getItem('storeId'),
            orderInfo: {},
            returnResponses: [{id: 'SelectResponse', description:'Select'}],
            orderItemDetails: {},
            returnOrderHeader:{},
            returnButtonDisable: true, 
            totalRefund:0,
            requestRMAData:{},
            returnRMAID:"",
            errorMsg:"",
            showReturnPopUp: false,
            exchangeStatus: {},
            isExchange: false,
            exchangeItems: {},
            returnResponseSelected: "",            
            hasCreditItem: false
        }
        this.returnPopUpModal = React.createRef()
        this.showReasonsForReturn = this.showReasonsForReturn.bind(this);
        this.setReasonForReturn = this.setReasonForReturn.bind(this);
        this.setExchange = this.setExchange.bind(this);
        this.setExchangeItem = this.setExchangeItem.bind(this);
        this.returnButton = this.returnButton.bind(this);
        this.getRMADetails = this.getRMADetails.bind(this); 
        this.onWaiverChange = this.onWaiverChange.bind(this);
        this.handleReturnResponsesChange = this.handleReturnResponsesChange.bind(this);
        this.handleReturnedInStoreCheck = this.handleReturnedInStoreCheck.bind(this);
    }
     
    async componentWillMount() {
        if (this.props.items) {
            this.setState({
                orderItemDetails: this.props.items,
            });
            // open RMA popup from Orderlist page
            if (this.props.returnIdFromOrderListing) {
                this.props.fetchRMAItemDetails(this.props.returnIdFromOrderListing);
                setTimeout(function () {
                    $("#rmaPopUpModal").modal('show')
                }, 100);
            }
        }
        if (this.props.orderMap) {
            this.setState({
                orderInfo: this.props.orderMap,
            });
        }
        if (this.props.contactInfo) {
              let temporalAddress = (await this.props.contactInfo).addressMap;
                 if(temporalAddress.toName !=='Digital Product Facility'){
                     this.setState({
                            returnAddress: (await this.props.contactInfo).addressMap,
                     });
                 }
        }
        if (this.props.returnResponses) {
            this.setState({ returnResponses: [...this.state.returnResponses, ...this.props.returnResponses] })
        }
        window.sessionStorage.removeItem('shippoError');
    }
     //update the state value
     componentWillReceiveProps(nextProps){
        if (nextProps.items) {
            this.setState({
                orderItemDetails: nextProps.items,
            });
        }
        if (nextProps.orderMap) {
            this.setState({
                orderInfo: nextProps.orderMap,
            });
        }
        //display the shippo api error message
        if(window.sessionStorage.getItem('shippoError')){
            var errMsg = window.sessionStorage.getItem('shippoError');
            if (errMsg.indexOf("P.O. Boxes are not supported") > -1) {
                errMsg = "PO Box addresses are not currently supported as a return address. Please contact Customer Service for further assistance.";
            }
            this.setState({
                errorMsg: errMsg
            });
        }
        this.setState({
            returnOrderHeader: {}
        });   
        this.setState({
            returnButtonDisable: true
        });
    }

    closePopUp() {
        $(this.returnPopUpModal.current).modal('hide');
        if(!window.sessionStorage.getItem('shippoError')){
            $(this.returnLabelPopUpModal.current).modal('show');
            window.sessionStorage.removeItem('shippoError');
        }
        this.setState({
            showReturnPopup: false
        })
    }

    showPopUp() {
        $(this.returnPopUpModal.current).modal('show');
        this.setState({
            showReturnPopup: true
        })
    }

    // show the Form for Reason for Return and Return notes block
    showReasonsForReturn(e) { 
        let tempOrderItemDetails = this.state.orderItemDetails;
        let id = e.target.id;
        let quantity = parseInt(e.target.value,10);
        let totalQuantity = tempOrderItemDetails[id].quantity;
        tempOrderItemDetails[id].returnQuantity = quantity;

        // unset the returnReason and Notes    
        if (quantity === 0) {
            tempOrderItemDetails[id].returnReason = "";
            tempOrderItemDetails[id].returnNotes = "";
            tempOrderItemDetails[id].returnReasonId = "";
            tempOrderItemDetails[id].returnedInStore = false;
        }

        // assign first value of Return Reason Array for  returnReason by default
        if (tempOrderItemDetails[id].returnReason === "" && quantity !== 0) {
            // tempOrderItemDetails[id].returnReason = this.props.returnReasonList.returnReasons[0].value;
            // tempOrderItemDetails[id].returnReasonId = this.props.returnReasonList.returnReasons[0].key; 
            tempOrderItemDetails[id].returnReasonId = "select";
            
        }

        const finalPrice = (tempOrderItemDetails[id].price + this.getDiscount(tempOrderItemDetails[id])) || 0.0
        tempOrderItemDetails[id].returnPrice = quantity !== 0 ? quantity * finalPrice.toFixed(2) + (tempOrderItemDetails[id].tax / totalQuantity * quantity) : quantity * finalPrice.toFixed(2);

        this.setState({
            orderItemDetails: tempOrderItemDetails
        });  
        this.returnButton(2);
    }

    //get the Reason for Return and Notes from the user
    setReasonForReturn(e) {

        let temp = this.state.orderItemDetails;
        let targetId = e.target.id.split('_');

        if (targetId[1] === 'returnReason'){
            temp[targetId[0]].returnReason = e.target.options[e.target.selectedIndex].text;
            temp[targetId[0]].returnReasonId = e.target.value; 
        }
        else
            temp[targetId[0]].returnNotes = e.target.value;

        this.setState({
            orderItemDetails: temp
        });
    }

    handleReturnResponsesChange(e) {
        let tempOrderItemDetails = this.state.orderItemDetails;
        let targetId = e.target.id.split('_')[0];
        let responseTypeId = e.target.value;
        let responseType = e.target.options[e.target.selectedIndex].text;
        tempOrderItemDetails[targetId[0]].returnResponse = responseType;
        tempOrderItemDetails[targetId[0]].returnResponseId = responseTypeId;
        this.setState({
            orderItemDetails: tempOrderItemDetails
        });
    }


    setExchange(e) {
        let isExchange = e.target.value === 'Yes'
        let targetId = e.target.id.split('_')[0];
        const newStatus = {
            ...this.state.exchangeStatus,
            [targetId]: isExchange
        }

        let temp = this.state.orderItemDetails;
        temp[targetId].isExchange = isExchange
        temp[targetId].exchangeItem = "select"

        this.setState({
            exchangeStatus: newStatus,
            isExchange: Object.values(newStatus).find(el => el) === true,
            orderItemDetails: temp
        }, () => {
            this.returnButton(2);   
        })
    }

    setExchangeItem(e) {
        let targetId = e.target.id.split('_')[0];
        let exchangeProductId = e.target.value
        let temp = this.state.orderItemDetails;

        if (exchangeProductId === "select") {
            return
        }

        let exchangeItemList = this.state.orderItemDetails[targetId].exchangeItemList;
        let exchangeItem = exchangeItemList.find(el => el.productId === exchangeProductId)

        temp[targetId].exchangeItem = exchangeItem

        this.setState({
            exchangeItems: {
                ...this.state.exchangeItems,
                [targetId]: exchangeItem
            }
        }, () => {
            this.returnButton(2);
        })
    }
     
    //Return button functionality 
    returnButton(flag) {
        let orderItems = this.state.orderItemDetails;
        let tempReturnOrderHeader =  this.state.orderInfo;       
        let shipping = 0;
        let exchangeShipping = 0;
        let splitTax = "";
        let returnItemsTemp = [];
        let exchangeItemsTemp = [];
        let refundSubtotal = 0;
        let exchangeTotal = 0
        let refundedAmount=0;
        let RMA ={};
        let disableReturn;
        let returnReasonEmpty = false;
        let noReturnLabel = false;
        let exchangeItemEmpty = false;
        let enableEvenChanges = false;
        let hasCreditItem = false;
        let returnResponseEmpty = false;
        this.setState({
            errorMsg: ""
        });
        if(this.props.returnSetting.returnShippingCost!== undefined)
           shipping = this.props.returnSetting.returnShippingCost;

        if(this.props.returnSetting.noReturnLabel === 'Y') {
            noReturnLabel = true;
        }
        if (this.state.requestRMAData.waiveLabelCost) {
            shipping = 0
        }

        if(this.props.returnSetting.noReturnLabel !== undefined  && this.props.returnSetting.noReturnLabel === 'Y') {
            noReturnLabel = true;
        }

        if(this.props.returnSetting.splitTax !== undefined)
               splitTax = this.props.returnSetting.splitTax;


        if(this.props.returnSetting.enableEvenChanges !== undefined  && this.props.returnSetting.enableEvenChanges === 'Y') {
            enableEvenChanges = true;
        }

        if(this.props.returnSetting.exchangeShippingCost!== undefined && !enableEvenChanges){
            exchangeShipping = this.props.returnSetting.exchangeShippingCost;
        } else {
            exchangeShipping = 0;
        }

        for (var i = 0; i < orderItems.length; i++) {
            if (orderItems[i].returnID === "" && orderItems[i].returnQuantity !== 0) {
                returnItemsTemp.push(orderItems[i]);
                if (enableEvenChanges && orderItems[i].isExchange){
                    refundSubtotal += 0;
                } else {
                    let unitTaxAmount =  orderItems[i].tax / orderItems[i].totalItemQuantity;
                    let totalRefund = (this.getPaidPrice(orderItems[i]) + unitTaxAmount) * orderItems[i].returnQuantity;
                    refundSubtotal += totalRefund;
                }
                if(orderItems[i].returnReasonId === 'select')
                    returnReasonEmpty = true;

                if (orderItems[i].returnResponse === 'Select') {
                    returnResponseEmpty = true;
                } else if (orderItems[i].returnResponse === 'RrspCredit') {
                    hasCreditItem = true;
                    this.setState({
                        hasCreditItem: hasCreditItem
                    });
                }
                if (orderItems[i].refundedAmount)
                {
                    refundedAmount+=orderItems[i].refundedAmount;
                }
                tempReturnOrderHeader.returnedInStore = orderItems[i].returnedInStore;
            }
            if (orderItems[i].isExchange) {
                if (orderItems[i].exchangeItem === "select") {
                    exchangeItemEmpty = true
                } else {
                    exchangeItemsTemp.push(orderItems[i]);
                }
            }
        }

        //Add the exchange items
        for (const key of Object.keys(this.state.exchangeItems)) {
            if (this.state.exchangeStatus[key] && !enableEvenChanges) {
                exchangeTotal += this.state.exchangeItems[key].price
            }
        }

        //Calculate Total Estimated Refund
        tempReturnOrderHeader.refundSubtotal = refundSubtotal;
        tempReturnOrderHeader.exchangeTotal = exchangeTotal
        tempReturnOrderHeader.refundShipping = shipping;
        tempReturnOrderHeader.exchangeShipping = exchangeShipping;
        tempReturnOrderHeader.refundedAmount = refundedAmount;
        tempReturnOrderHeader.splitTax = splitTax;
        let totalEstimatedRefund = 0.0
        if (noReturnLabel) {
            tempReturnOrderHeader.refundShipping = 0;
            totalEstimatedRefund = (refundSubtotal - refundedAmount);
        } else if (!this.state.isExchange) {
            totalEstimatedRefund = Math.max((refundSubtotal - shipping - exchangeTotal-refundedAmount),0)
        } else {
            totalEstimatedRefund = Math.max((refundSubtotal - exchangeShipping - exchangeTotal-refundedAmount),0)
        }

        console.log(tempReturnOrderHeader);
        tempReturnOrderHeader.totalEstimatedRefund = totalEstimatedRefund.toFixed(2);
        tempReturnOrderHeader.storeId = this.state.storeId;
        tempReturnOrderHeader.originId = ORIGIN_ID;
        tempReturnOrderHeader.email = this.props.billInfoMap.customerEmailId
        tempReturnOrderHeader.customerFirstName = this.props.billInfoMap.customerFirstName

        this.setState({
            returnOrderHeader: tempReturnOrderHeader
        });  
        RMA.returnItems =  returnItemsTemp;
        RMA.returnOrderHeader = tempReturnOrderHeader;
        RMA.returnPolicy  = this.props.returnSetting;
        RMA.waiveLabelCost = this.state.requestRMAData.waiveLabelCost
        RMA.isExchange = this.state.isExchange;
        RMA.returnResponse = this.state.returnResponseSelected;
        RMA.hasCreditItem = this.state.hasCreditItem;
        if (this.props.facilityId) RMA.facilityId = this.props.facilityId;
        this.setState({
            requestRMAData: RMA
        });  

        // Disable the Return button
        if(returnItemsTemp.length === 0)
            disableReturn = true;
        else
            disableReturn = false;

        this.setState({
            returnButtonDisable: disableReturn
        });   
        
        // Open the Return PopUp
        if(flag === 1 && returnReasonEmpty === false && exchangeItemEmpty === false && returnResponseEmpty === false)
            this.showPopUp();
        else if(flag === 1 && returnReasonEmpty === true) {
            this.setState({
                errorMsg: 'Please select a valid Reason!'
            });
        } else if (flag === 1 && exchangeItemEmpty === true) {
            this.setState({
                errorMsg: 'Please select a valid exchange item!'
            });
        } else if (flag === 1 && returnResponseEmpty === true) {
            this.setState({
                errorMsg: 'Please select a valid return response!'
            });
        }

    }
 // Fetch RMA details when click the Return Id
    getRMADetails(id){   
        this.props.fetchRMAItemDetails(id);
    }

    handleReturnedInStoreCheck(e){
        let id = e.target.id;
        let orderItems = this.state.orderItemDetails;
        let checked = e.target.checked;
        if (orderItems[id].returnQuantity !== 0) {
            orderItems[id].returnedInStore = checked;
        }
        this.setState({
            orderItemDetails : orderItems
        });
    }

    onWaiverChange(e){
        let checked = e.target.checked
        let RMA = this.state.requestRMAData
        RMA.waiveLabelCost = checked
        this.setState({
            requestRMAData: RMA
        });
        this.returnButton(2);
    }

    getRMADataById(id){
        var self = this;
        Promise.resolve(this.props.getRMAData(id)).then(function(value) {
            self.shippingLabelUrl = value.messages;
            if(value.hasOwnProperty('orderMap') && value.orderMap.hasOwnProperty('shippingLabelUrl')) {
                self.shippingLabelUrl = value.orderMap.shippingLabelUrl;
            }
            return value;
        });
        return self.shippingLabelUrl;
    }

    getPaidPrice(item){
        if(item.discountList) {
            return item.price + this.getDiscount(item)
        }

        return item.price;
    }

    getDiscount(item) {
        let totalDiscountAmount = 0;
        if (item.discountList) {
            item.discountList.forEach( discountItem => {

                // Detect discrepancy between refund amount, I know it's ugly but the alternative is to modify the database to retroactively fix records
                const discount = item && item.quantity > discountItem.quantity && discountItem.quantity === 1 &&
                (discountItem.itemDescription.includes("across all") || discountItem.itemDescription.includes("across entitled") || discountItem.itemDescription.includes("line_item"))  ?
                    discountItem.unitAmount / item.quantity : discountItem.unitAmount;

                totalDiscountAmount += discount;
            });
        }
        return totalDiscountAmount;
    }

    render() {

        let inputClasses = classNames({
            'editform': true, 'col-sm-12': true
        });
        let returnButtonClass = classNames({
            'btn':true,'float-right':true,'return-active':this.state.returnButtonDisable ? false : true,
            'return-disable': this.state.returnButtonDisable ? true : false
        })       
        
         
    return (
        <React.Fragment>
            <div className="col">
                <div className="returnsTo">
                    <p style={{marginBottom: '0'}}>
                        {this.state.returnAddress &&
                        <React.Fragment>
                            <span className="font-weight-bold">Returns To</span><br />
                            {this.state.returnAddress.toName}<br />
                            {this.state.returnAddress.address1}<br />
                            {this.state.returnAddress.city}&nbsp;
                            {this.state.returnAddress.stateProvinceGeoId.replace('USA_', '')}&nbsp;
                            {this.state.returnAddress.postalCode}
                            <br />
                        </React.Fragment>
                        }
                    </p>
                </div>
                {this.props.returnLabelSetting && this.props.returnLabelSetting === 'Y' && this.state.returnAddress && <p>The following items must be manually shipped to the return address:</p>}
                <table className="table order-detail">
                    <thead>
                        <tr>
                            <th>ITEM</th>
                            <th>SKU</th>
                            <th>RETURNING</th>
                            {this.state.storeClerkToken &&
                                <React.Fragment>
                                    <th>RETURNED IN STORE</th>
                                    <th>RESPONSE TYPE</th>
                                </React.Fragment>
                            }                          
                            {this.state.orderInfo.returnedIdFlag &&
                                <React.Fragment> 
                                    <th>STATUS & TRACKING</th>
                                    <th> RETURN NUMBER</th>
                                </React.Fragment>
                            }
                              <th align="right">PRICE</th>
                        </tr>
                    </thead>
                    {this.state.orderItemDetails.length >0 &&
                        <tbody>
                            {this.state.orderItemDetails.map((items, index) => (
                             <React.Fragment key={index}>
                                <tr >
                                        <td>
                                            <div className="td-center">
                                                {items.imageUrl ?
                                                <div className="td-valign">
                                                    <img src={items.imageUrl} alt="" className="product-img" />
                                                 </div>
                                                :
                                                   <div className="search-product-image td-valign">
                                                   </div>
                                                }

                                            <ul className="reason-notest width-80 td-valign ">
                                                <li className="p-name">  {items.itemName} </li>
                                                {items.color &&
                                                    <li className="p-name">Color : {items.color}</li>
                                                }
                                                {items.size &&
                                                    <li className="p-name">Size : {items.size}</li>
                                                }
                                                {items.hasCustomReturn &&
                                                    <li className="p-name final-sale">{items.returnMessage}</li>
                                                }
                                                {!items.itemEligibleToReturn &&
                                                    <li className="p-name final-sale">FINAL SALE</li>
                                                }
                                                  {items.returnID &&
                                                  <React.Fragment>
                                                       {items.returnReason !=='' &&
                                                         <li className="reason">Reason  :  {items.returnReason} </li>
                                                        }
                                                         {items.returnNotes &&
                                                            <li className="reason"> Notes  :  {items.returnNotes} </li>
                                                         }
                                                    </React.Fragment>
                                                  }
                                            </ul>                                         
                                            </div>
                                        </td>

                                        <td>{items.sku}</td>

                                        <td>
                                            {!items.returnID && !items.hasCustomReturn ?
                                                <React.Fragment>
                                                    {!(this.state.orderInfo.eligibilityOverriden ||(this.state.orderInfo.orderEligibility && items.itemEligibleToReturn)) ?
                                                        <div>-</div>
                                                        :
                                                       <React.Fragment>
                                                        <select id={index} value={items.returnQuantity} onChange={this.showReasonsForReturn} className="selector-width">
                                                            {items.options.map((val) => (
                                                                <option key={val.key} value={val.value}>{val.value}</option>
                                                            ))}
                                                        </select>
                                                        <svg role="presentation" className="icon icon--arrow" width="62px" height="60px" viewBox="-458 261.7 41.8 38.3">
                                                            <polygon className="icon__caret" points="-432.9,281.4 -437.1,286.4 -441.3,281.4 "></polygon>
                                                        </svg>
                                                      </React.Fragment>
                                                    }
                                                </React.Fragment>
                                                :
                                                <div> {items.returnQuantity}</div>
                                            }
                                        </td>

                                        {this.state.storeClerkToken &&
                                            <React.Fragment>
                                                <td><input disabled={items.returnID !== ''} type="checkbox" id={index} name="name" onChange={this.handleReturnedInStoreCheck} checked={(items.returnedInStore && items.returnQuantity!==0)} value="" /></td>
                                                <td>
                                                    <select id={index + '_returnResponse'} value={items.returnResponseId} disabled={items.returnID !== ''} onChange={this.handleReturnResponsesChange} className="selector-response">                                                            
                                                        {this.state.returnResponses.map((val) => (
                                                            <option key={val.id} value={val.id}>{val.description}</option>
                                                        ))}
                                                    </select>
                                                    <svg role="presentation" className="icon icon--arrow" width="62px" height="60px" viewBox="-458 261.7 41.8 38.3">
                                                            <polygon className="icon__caret" points="-432.9,281.4 -437.1,286.4 -441.3,281.4 "></polygon>
                                                    </svg>
                                                </td>
                                            </React.Fragment>
                                        }                                      

                                        {this.state.orderInfo.returnedIdFlag &&
                                            <React.Fragment>
                                                <td>
                                                    {(items.returnedInStore && items.returnID)?
                                                        <div>Returned In Store</div>
                                                    :
                                                        <React.Fragment>
                                                            {items.returnID && (
                                                                <React.Fragment>
                                                                    <p className="mb-0">Return{items.returnTrackingStatus}</p>
                                                                    <a style={{marginTop: '0.5em'}} target="_blank" href={items.returnTrackingUrl} className="returnId-link">{items.returnTrackingNumber}</a>
                                                                </React.Fragment>
                                                            )}
                                                        </React.Fragment>
                                                    }
                                                </td>

                                                <td>
                                                    {items.returnID && (
                                                        <React.Fragment>
                                                            <div>{items.returnID}</div>
                                                            <NavLink to={PRODUCTION_PATH + this.state.storeId + RETURNINSTRUCTIONS_PAGE + "/" + items.returnID}>
                                                                {'Print label & return authorization'}
                                                            </NavLink>
                                                        </React.Fragment>
                                                    )}
                                                </td>
                                            </React.Fragment>
                                        }
                                        <td align="right">${(this.getPaidPrice(items) || 0.0 ).toFixed(2)}
                                            {items.discountList && this.getDiscount(items) < 0 &&
                                                <div className="white-space-nowrap">
                                                    <small>discount ${(-this.getDiscount(items) || 0.0).toFixed(2)}</small>
                                                </div>
                                            }
                                            <div className="white-space-nowrap">
                                                <small>+ tax ${(((items.tax / items.totalItemQuantity) * items.quantity) || 0.0).toFixed(2)}</small>

                                            </div>
                                            {items.refundedAmount &&
                                            <div className="white-space-nowrap">
                                                <small>- refund ${(items.refundedAmount || 0.0).toFixed(2)}</small>
                                            </div>
                                            }
                                        </td>
                                    </tr>

                                    {!items.returnID && items.returnQuantity !== 0 &&

                                    <React.Fragment>
                                        <tr className={inputClasses}>

                                            {/* <td className="edit-width" colSpan=""></td> */}

                                            <td className="edit-width" align="right" colSpan="2">
                                                <div className="form-group p-relative">
                                                    <label className="required reason-label">Reason for Return</label>
                                                    <div>                                                       
                                                        <select className="returnReason-width" id={index + '_returnReason'} value={items.returnReasonId} onChange={this.setReasonForReturn} >
                                                          <option key="select" value="select">Select Reason</option>
                                                          {this.props.returnReasonList.returnReasons &&
                                                          <React.Fragment>
                                                                {this.props.returnReasonList.returnReasons.map((val) => (                                                        
                                                                <option key={val.key} value={val.key}>{val.value}</option>
                                                                ))}
                                                            </React.Fragment>
                                                          }
                                                        </select>
                                                        <svg role="presentation" className="icon icon--arrow" width="62px" height="60px" viewBox="-458 261.7 41.8 38.3">
                                                            <polygon className="icon__caret" points="-432.9,281.4 -437.1,286.4 -441.3,281.4 "></polygon>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </td>

                                            {(this.state.requestRMAData.returnPolicy.exchangeEnabled === "N" || !this.state.orderInfo.exchangeEligibility)  &&
                                                <React.Fragment>
                                                    <td colSpan="4">
                                                        <div className="form-group col-sm-8 no-padding">
                                                            <label >Notes </label>
                                                            <textarea id={index + '_returnNotes'} onChange={this.setReasonForReturn} value={items.returnNotes} type="text" maxLength="120" className="form-control input-ctrl" ></textarea>
                                                        </div>
                                                    </td>
                                                    {this.state.storeClerkToken && this.state.orderInfo.returnedIdFlag &&
                                                    <td></td>
                                                    }
                                                </React.Fragment>
                                            }


                                            {this.state.requestRMAData.returnPolicy.exchangeEnabled === "Y" && items.enableExchanges && this.state.orderInfo.exchangeEligibility &&  <td colSpan="2" align="left" className="edit-width">
                                                {items.exchangeItemList && items.exchangeItemList.length > 0 &&
                                                    <div className="form-group p-relative">
                                                        <label className="required text-label">Prefer an Exchange?</label>
                                                        <div>
                                                            <select id={index + '_preferExchange'} onChange={this.setExchange} className="selector-width">
                                                                <option key="No" value="No">No</option>
                                                                <option key="Yes" value="Yes">Yes</option>
                                                            </select>
                                                            <svg role="presentation" className="icon icon--arrow" width="62px" height="60px" viewBox="-458 261.7 41.8 38.3">
                                                                <polygon className="icon__caret" points="-432.9,281.4 -437.1,286.4 -441.3,281.4 "></polygon>
                                                            </svg>
                                                        </div>
                                                    </div>
                                                }
                                            </td>}
                                        </tr>
                                        {this.state.requestRMAData.returnPolicy.exchangeEnabled === "Y" && this.state.orderInfo.exchangeEligibility && <tr className={inputClasses}>
                                            <td colSpan="2" align="right" className="edit-width">
                                                {this.state.exchangeStatus[index] && <div className="form-group p-relative">
                                                    <label className="required text-label">Choose a replacement item</label>
                                                    <select id={index + '_exchangeItem'} onChange={this.setExchangeItem} className="returnReason-width">
                                                        <option key="select" value="select">Select Exchange Item</option>
                                                        {items.exchangeItemList.map((val) => (
                                                            <option key={val.productId} value={val.productId}>{val.productName}</option>
                                                        ))}
                                                    </select>
                                                    <svg role="presentation" className="icon icon--arrow" width="62px" height="60px" viewBox="-458 261.7 41.8 38.3">
                                                        <polygon className="icon__caret" points="-432.9,281.4 -437.1,286.4 -441.3,281.4 "></polygon>
                                                    </svg>
                                                </div>}
                                            </td>
                                            <td colSpan="2" align="left">
                                                <div className="form-group p-relative">
                                                    <label >Notes </label>
                                                    <textarea id={index + '_returnNotes'} onChange={this.setReasonForReturn} value={items.returnNotes} type="text" maxLength="120" className="form-control input-ctrl" ></textarea>
                                                </div>
                                            </td>
                                            {this.state.storeClerkToken && this.state.orderInfo.returnedIdFlag &&
                                            <td></td>
                                            }
                                        </tr>}
                                    </React.Fragment>
                                    }
                                </React.Fragment>
                            ))}
                        </tbody>
                    }
                </table>
                {/* <hr></hr>    */}
                    <div className="float-right">
                    {!this.state.returnButtonDisable ?
                     <table className="table table-borderless refund-table" width="300px">                    
                        <tbody>
                           <tr>
                              <td align="right">Refund Subtotal</td>
                              <td className="float-right">${(this.state.returnOrderHeader.refundSubtotal || 0.0).toFixed(2)}</td>
                           </tr>
                           {!(this.state.requestRMAData.returnPolicy.showReturnShipping === 'N' && this.state.returnOrderHeader.refundShipping === 0) && !this.state.isExchange &&
                               <tr>
                                   <td align="right">Return Shipping</td>
                                   <td className="float-right">
                                       <i>{this.state.returnOrderHeader.refundShipping === 0 ? 'free' + (this.state.waiveLabelCost && this.state.returnOrderHeader.refundShipping > 0 ? ' was ($' + this.state.returnOrderHeader.refundShipping.toFixed(2) : '') : '$' + (this.state.returnOrderHeader.refundShipping || 0.0).toFixed(2)}</i>
                                   </td>
                               </tr>
                           }
                           {!!this.state.returnOrderHeader.refundedAmount &&
                               <tr>
                                   <td align="right">-Refund</td>
                                   <td className="float-right">
                                       ${(this.state.returnOrderHeader.refundedAmount).toFixed(2)}
                                   </td>
                               </tr>
                           }
                           {this.state.storeClerkToken && !this.state.returnedIdFlag &&
                           <tr>
                               <td align="right"><input type="checkbox" id="waiveReturnFee" name="feeWaiverCheckbox" onChange={this.onWaiverChange}/></td>
                               <td align="left"><label htmlFor="feeWaiverCheckbox">Waive return label fee</label></td>
                           </tr>
                           }
                           {this.state.requestRMAData.returnPolicy.showExchangeShipping === 'Y' && this.state.returnOrderHeader.exchangeShipping !== 0 && this.state.isExchange &&
                           <tr>
                               <td align="right">Exchange Shipping</td>
                               <td className="float-right">
                                   <i>{this.state.returnOrderHeader.exchangeShipping === 0 ? 'free' : '$' + (this.state.returnOrderHeader.exchangeShipping || 0.0).toFixed(2)}</i>
                               </td>
                           </tr>
                           }
                           {this.state.isExchange &&
                           <tr>
                               <td align="right">Exchange</td>
                               <td className="float-right">
                                   <i>${(this.state.returnOrderHeader.exchangeTotal || 0.0).toFixed(2)}</i>
                               </td>
                           </tr>
                           }
                           <tr>
                              <td align="right"><strong>Total Estimated Refund</strong></td>
                              <td className="float-right"><strong>${this.state.returnOrderHeader.totalEstimatedRefund}</strong></td>
                           </tr>
                        </tbody>
                     </table>
                     :
                     <div></div>
                     
                    }     
                    {this.state.errorMsg &&
                        <div id="error" className="float-right error mb-2">  
                            {this.state.errorMsg}               
                        </div>
                    }            
                     <div><button disabled={this.state.returnButtonDisable} type="button" onClick={() => this.returnButton(1)}  className={returnButtonClass} >RETURN</button></div>
                  </div>                  
                   
                </div>               
               {/* Return button model pop up Component         */}

                <div className="modal fade return-popup" id="returnPopUpModal" ref={this.returnPopUpModal}>
                    <ReturnPopUp requestRMA={this.state.requestRMAData} show={this.state.showReturnPopUp} handleClose={this.closePopUp.bind(this)}/>
                </div>
              {/* RMA Popup  */}
                <RMAPopUP />   
              
            </React.Fragment>
        );
    }
}
 

const mapStateToProps = (state) => ({
    returnIdFromOrderListing: state.orderDataDetails.returnIdFromOrderListing,
    returnReasonList: state.storeSettingData.storeDesign.returnReasonsMap,
    rmaData: state.orderDataDetails.returnRMAItemDetails,
    returnSetting: state.storeSettingData.storeDesign.returnSettingsMap
});

export default connect(mapStateToProps, {fetchRMAItemDetails,getRMAData})(OrderItemListing);



// WEBPACK FOOTER //
// ./src/components/OrderDetails/OrderItemListing.js